import React from 'react'
import { Route } from 'react-router-dom'
import { useUser } from '@fs/zion-user'
import { NoticeLoading } from '@fs/zion-icon'
import { css } from '@emotion/core'

const center = css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

function LoadingSpinner() {
  return (
    <div data-testid="spinner" css={center}>
      <NoticeLoading size="xl" />
    </div>
  )
}

function AuthRouteWrapper({ signedIn, userLoading, children }) {
  if (signedIn) {
    return children
  }
  if (userLoading) {
    return <LoadingSpinner />
  }
  typeof window !== 'undefined' &&
    window.location.replace(`/auth/familysearch/login?returnUrl=${encodeURIComponent(window.location.pathname)}`)

  return <LoadingSpinner />
}

export default function AuthRoute({ component: Component, children, ...rest }) {
  const userInfo = useUser()

  return (
    <Route {...rest}>
      {(props) => <AuthRouteWrapper {...userInfo}>{children || <Component {...props} />}</AuthRouteWrapper>}
    </Route>
  )
}
